<template>
  <div v-if="!isReady" class="fixed inset-0 bg-white flex items-center justify-center z-50">
    <div class="flex flex-col items-center gap-4">
      <div class="animate-spin h-8 w-8 text-blue-500 border-4 border-slate-200 border-t-blue-500 rounded-full"></div>
      <div class="text-slate-500 font-medium">Loading resources...</div>
    </div>
  </div>
  
  <NuxtLayout v-else>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
const isReady = ref(false)

// 🌟 核心逻辑：确保在客户端挂载的第一时间对齐语言
onMounted(() => {
  if (process.client) {
    const savedLocale = localStorage.getItem('app_locale')
    if (savedLocale && ['en', 'zh'].includes(savedLocale)) {
      locale.value = savedLocale
    }
    isReady.value = true
  }
})
</script>
